import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

/**
 * Activity Log — trail audit tiap cycle, live saat bot running.
 */
export function ActivityPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['bot-activity'],
    queryFn: () =>
      api.get<{
        activity: {
          running: boolean;
          cycle_id: string | null;
          steps: Array<{ at: string; level: string; message: string }>;
          result: any;
        };
      }>('/api/bot/activity'),
    refetchInterval: (q) => {
      const act = (q.state.data as any)?.activity;
      return act?.running ? 1000 : 8000;
    },
  });

  const activity = data?.activity;
  const steps = activity?.steps || [];
  const result = activity?.result;

  return (
    <div className="gl-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 600, color: 'var(--gl-text)' }}>Aktivitas Nevi</div>
          <div style={{ fontSize: 12, color: 'var(--gl-text-muted)', marginTop: 4 }}>
            Trail audit tiap siklus Nevi — live update saat berjalan
          </div>
        </div>
        {activity?.running && (
          <span style={{ fontSize: 12, color: 'var(--gl-emerald)', fontWeight: 600 }}>
            ● LIVE
          </span>
        )}
      </div>

      {error && (
        <div className="settings-alert settings-alert--error" style={{ marginBottom: 16 }}>
          {(error as Error).message}
        </div>
      )}

      {isLoading ? (
        <div className="gl-empty">Memuat…</div>
      ) : steps.length === 0 && !result ? (
        <div className="gl-empty">Belum ada aktivitas. Minta Nevi analisis dari Ringkasan.</div>
      ) : (
        <div className="g-card" style={{ padding: 0, overflow: 'hidden' }}>
          {/* Header info */}
          {activity?.cycle_id && (
            <div style={{
              padding: '12px 18px', borderBottom: '1px solid rgba(255,255,255,0.06)',
              fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--gl-text-faint)',
              display: 'flex', gap: 20, flexWrap: 'wrap',
            }}>
              <span>cycle: {activity.cycle_id}</span>
              {result?.candidates_total != null && <span>produk: {result.candidates_total}</span>}
              {result?.candidates_passed != null && <span>lolos: {result.candidates_passed}</span>}
              {result?.duration_ms != null && <span>durasi: {(result.duration_ms / 1000).toFixed(1)}s</span>}
            </div>
          )}

          {/* Steps log */}
          <div style={{
            padding: 10, maxHeight: 500, overflowY: 'auto',
            fontFamily: 'var(--font-mono)', fontSize: 12, lineHeight: 1.6,
          }}>
            {steps.map((s, i) => (
              <div key={i} style={{
                padding: '4px 8px', borderRadius: 4,
                color: s.level === 'error' ? 'var(--gl-rose)'
                      : s.level === 'warn' ? 'var(--gl-amber)'
                      : s.level === 'ok' ? 'var(--gl-emerald)'
                      : 'var(--gl-text-muted)',
                background: s.level === 'error' ? 'rgba(251,113,133,0.06)' : 'transparent',
              }}>
                <span style={{ opacity: 0.4, marginRight: 8 }}>
                  {s.at ? new Date(s.at).toLocaleTimeString('id-ID') : ''}
                </span>
                {s.message}
              </div>
            ))}
          </div>

          {/* Result summary */}
          {result && !activity?.running && (
            <div style={{
              padding: '12px 18px', borderTop: '1px solid rgba(255,255,255,0.06)',
              fontSize: 12, color: 'var(--gl-text-muted)',
            }}>
              <strong>Result:</strong> {result.summary || JSON.stringify(result)}
              {result.warnings?.length > 0 && (
                <div style={{ marginTop: 6 }}>
                  <span style={{ color: 'var(--gl-amber)' }}>⚠️ Warnings:</span>
                  <ul style={{ margin: '4px 0 0', paddingLeft: 18 }}>
                    {result.warnings.map((w: string, i: number) => (
                      <li key={i}>{w}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}